export default __webpack_public_path__ + "static/media/logo-md-768w.4bf25fb3.avif";